// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__1u2lc","paymentContainer":"PaymentPage_paymentContainer__33mtd"};